export const CUSTOM_TOKEN_TIMEOUT_PROPERTY_ID = '37';
export const ASI_TIMEOUT_PROPERTY_TYPE_ID = '68';
export const DEFAULT_CUSTOM_TOKEN_TIMEOUT_VALUE = "1800";